import './_init';

$(() => {

  //デバイスがPCビューかSPビューかをapp.deviceに格納
  let resizeTimer;
  util.win.resizeFunctions.checkDevice = () => {
    if (util.win.w > 760 || device.tablet()) {
      if (!app.device || app.device == 'sp') {
        app.device = 'pc';
      }
    } else {
      if (!app.device || app.device == 'pc') {
        app.device = 'sp';
      }
    }
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      Waypoint.refreshAll();
    }, 100);
  }
  util.win.resizeFunctions.checkDevice();


  //ハンバーガーアイコンを押したときとマウスオーバーしたとき
  let $menuTrigger = $('#menuTrigger');
  $menuTrigger.on({
    click: (e) => {
      $('#header').toggleClass('open');
    }
  });
  let $lines = $('#menuTrigger span span');
  TweenMax.set($lines, {transformOrigin: 'left top'})
  let triggerTl = new TimelineMax({
    paused: true
  })
    .staggerTo($lines, 0.2, {transformOrigin: 'right top', scaleX: 0, ease: Power3.easeInOut}, 0.05)
    .staggerTo($lines, 0.2, {transformOrigin: 'left top', scaleX: 1, ease: Power3.easeInOut}, 0.05, '-=0.1')

  // .staggerFromTo($lines,0.15,{x:'-150%'},{x:'0%',ease:Power3.easeInOut},0.1,'-=0.2');
  triggerTl.play(0);
  $menuTrigger.on({
    mouseenter: () => {
      if (app.device == 'pc') {
        triggerTl.play(0);
      }
    }
  });

  //サブカテゴリーセレクターを押した時
  $('#subSelector .current').on({
    click: (e) => {
      $('#subSelector').toggleClass('open');
    }
  });

  $('#subSelector_news .current').on({
    click: (e) => {
      $('#subSelector_news').toggleClass('open');
    }
  });

  $('#subSelector_mini .current').on({
    click: (e) => {
      $('#subSelector_mini').toggleClass('open');
    }
  });


  //メニューのカレント
  $('#menuNav a').each((i, el) => {
    let $el = $(el);
    let href = $el.attr('href');
    let pathName = location.pathname.replace('index.html', '')
    if (href == pathName) {
      $el.parents('li').addClass('cur');
    }
  });

  //ページ毎の演出をbodyのClass名から振り分け
  var $body = $('body');
  if ($body.hasClass('top')) { // トップページの時
    app.scene = new Top();
  } else {  // 下層ページ
    app.load = new Load();
    app.header = new Header();
    if ($body.hasClass('worksIndex')) { //WORKS インデックス
      app.page = new WorksIndex('worksIndex');
    } else if ($body.hasClass('worksDetail')) { //WORKS 詳細
      app.page = new WorksDetail('worksDetail');
    } else if ($body.hasClass('newsIndex')) { //NEWSインデックス
      app.page = new NewsIndex('newsIndex');
    } else if ($body.hasClass('newsDetail')) { //NEWS 詳細
      app.page = new NewsDetail('newsDetail');
    } else if ($body.hasClass('about')) { //about
      app.page = new About('about');
    } else if ($body.hasClass('profile')) { //profile
      app.page = new  Profile('profile');
    } else if ($body.hasClass('Contact')) { //Contact
      app.page = new Contact('Contact');
    } else { //その他ページ
      app.page = new Page();
      new SlideIn();
    }
  }
  TweenMax.set('#wrapper', {autoAlpha: 1});


});

//共通下層ページ
class Page {
  constructor(id) {
    this.id = id;
    app.load.tl.play();
  }

  start() {
    // console.log(this.id);
  }
}

//News詳細ページ
class NewsDetail extends Page {
  constructor(id) {
    super(id);
    this.tl = new TimelineMax({
      paused: true
    })
      .from('#subSelector_news', 0.6, {marginTop: 50, autoAlpha: 0, ease: Power2.easeOut})
      .from('#detailMain .inner', 0.5, {x: '100%', ease: Power3.easeInOut}, '-=0.3')
      .from('#detailMain .image', 0.5, {x: '-100%', ease: Power3.easeInOut}, '-=0.5')
      .add(() => {
        new SlideIn();
      });
  }

  start() {
    this.tl.play();
  }
}

//Newsインデックス
class NewsIndex extends Page {
  constructor(id) {
    super(id);
    this.tl = new TimelineMax({
      paused: true
    })
      .from('#subSelector_news', 0.6, {marginTop: 50, autoAlpha: 0, ease: Power2.easeOut})
      .add(() => {
        new SlideIn();
      });
  }

  start() {
    this.tl.play();
  }
}

//Works詳細ページ
class WorksDetail extends Page {
  constructor(id) {
    super(id);
    this.tl = new TimelineMax({
      paused: true
    })
      .from('#subSelector', 0.6, {marginTop: 50, autoAlpha: 0, ease: Power2.easeOut})
      .from('#detailMain .inner', 0.5, {x: '100%', ease: Power3.easeInOut}, '-=0.3')
      .from('#detailMain .image', 0.5, {x: '-100%', ease: Power3.easeInOut}, '-=0.5')
      .add(() => {
        new SlideIn();
      });
  }

  start() {
    this.tl.play();
  }
}

//Worksインデックス
class WorksIndex extends Page {
  constructor(id) {
    super(id);
    this.tl = new TimelineMax({
      paused: true
    })
      .from('#subSelector', 0.6, {marginTop: 50, autoAlpha: 0, ease: Power2.easeOut})
      .add(() => {
        new SlideIn();
      });
    this.scroll();
  }

  start() {
    this.tl.play();
  }

  scroll() {
    var windowWidth,
      headerHeight;

    $(window).on('load resize', function () {
      windowWidth = $(window).width();
      if (windowWidth > 768) {
        headerHeight = 100;
      } else if (windowWidth <= 768) {
        var $header = $('#subSelector');
        var $headerHeight = $header.height();
        headerHeight = $headerHeight;
      }
    });

    var start_pos = 0;
    $(window).scroll(function (e) {
      var current_pos = $(this).scrollTop();
      if (current_pos > start_pos) {
        // console.log('down');
      } else {
        // console.log('up');
        if (headerHeight <= current_pos) {
          // window.console.log('tyo!!');
        }
      }
      start_pos = current_pos;
    });
  }
}

//Aboutページ
class About extends Page {
  constructor(id) {
    super(id);
    this.tl = new TimelineMax({
      paused: true
    })
      .from('#subSelector', 0.6, {marginTop: 50, autoAlpha: 0, ease: Power2.easeOut})
      .from('#aboutDetailMain .inner', 0.5, {x: '100%', ease: Power3.easeInOut}, '-=0.3')
      .from('#aboutDetailMain .image', 0.5, {x: '-100%', ease: Power3.easeInOut}, '-=0.5')
      .add(() => {
        new SlideIn();
      });
  }

  start() {
    this.tl.play();
  }
}

//Profileページ
class Profile extends Page {
  constructor(id) {
    super(id);
    this.tl = new TimelineMax({
      paused: true
    })
      .add(() => {
        new SlideIn();
      });
  }

  start() {
    this.tl.play();
  }
}

//スクロールでふわっと出てくる
//.slideIn のクラス
class SlideIn {
  constructor() {
    let $slideIn = $('.slideIn');
    $slideIn.each((i, el) => {
      let $el = $(el);
      setTimeout(() => {
        $el.waypoint(() => {
          let delay = $el.data('delay');
          delay = delay ? Number(delay) / 1000 : 0;
          TweenMax.to($el, 1, {y: 0, autoAlpha: 1, ease: Power3.easeOut, delay: delay});
        }, {
          offset: '90%'
        })
      }, i * 100);
    })

  }
}

//下層ページ共通ローディング
class Load {
  constructor() {
    // this.$logoProgress = $('#logo .progress');

    this.$progressBar = $('#progressBar');
    const loadingDuration = 1;
    this.tl = new TimelineMax({
      paused: true
    })
    // .to(this.$logoProgress,loadingDuration,{ width: '100%', ease: Power0.easeNone })
      .to(this.$progressBar, loadingDuration, {scaleX: 1, ease: Power0.easeNone}, 0)
      .set(this.$progressBar, {transformOrigin: '100% 0'})
      .add(() => {
        app.page.start();
        // $('body').addClass('loaded');
      })
      .to(this.$progressBar, 0.5, {scaleX: 0, ease: Power0.easeNone})
      .from('#headerNav ul, #header .langSwitcher, #menuTrigger, #breadCrumbs', 0.5, {
        y: -100,
        ease: Power3.easeOut
      }, '-=0.5');
  }
}

//下層ページ共通ヘッダー
class Header {
  constructor() {
    TweenMax.set('#header #subSelector_mini', {y: -20});
    this.tl = new TimelineMax({
      paused: true
    }).to('#header', 100, {y: -100, ease: Power0.easeNone})
      .set('#header', {className: '+=small'})
      .set('#header', {y: -60})
      // .to({},100,{})
      .add('transform')
      .to('#header', 200, {y: 0, ease: Power0.easeNone}, 'transform');
    // .to('.fixedTarget',200,{y:-40, ease:Power0.easeNone},'transform')
    // .to('#subSelector',200,{height:66,ease:Power0.easeNone},'transform')

    this.tl02 = new TimelineMax({
      paused: true
    })
      .to('#header #subSelector_mini', 100, {display: "none", opacity: "0.0", y: -20, ease: Power0.easeNone})
      .set('#header #subSelector_mini', {y: -20})
      .add('transform')
      .to('#header #subSelector_mini', 100, {
        y: 0,
        display: "block",
        opacity: "1.0",
        ease: Power0.easeNone
      }, 'transform');

    util.win.scrollFunctions.header = () => {
      const scrTop = Math.max(util.win.scrTop, 0);
      if (app.device == 'pc') {
        // PCの時
        if (scrTop < 400) {
          this.tl.seek(scrTop);
        } else {
          this.tl.progress(1);
        }

        if (scrTop < 100) {
          this.tl02.seek(scrTop);
          if ($('#subSelector_mini').hasClass('open')) {
            $('#subSelector_mini').toggleClass('open');
          }
        } else if (scrTop >= 100) {
          this.tl02.progress(1);
        }

      } else {
        // SP・タブレットの時
        this.tl.progress(0);
        this.tl02.progress(0);
      }
    };
    util.win.scrollFunctions.header();
    util.win.resizeFunctions.header = () => {
      util.win.scrollFunctions.header();
    };
    $('#menu').on({
      wheel: (e) => {
        e.preventDefault();
      }
    });
  }
}

//トップページ
class Top {
  constructor() {

    this.loadingItem = new lottieUtil('loadingItem', '/assets/json/thisone.json', 1);
    this.loadingItem.play();

    TweenMax.set('#headerNav, #header > .langSwitcher, #menuTrigger', {y: 30, autoAlpha: 0});

    this.$slide = $('#slides .slide');
    this.$lastBg = $('#lastBg');

    // 右側のページングナビを追加
    let pagerTemp = '<li><div><svg width="17" height="17" viewBox="0 0 17 17"><circle class="dot" cx="8.5" cy="8.5" r="2.5"/><circle class="line" cx="8.5" cy="8.5" r="7.5"/></svg></div></li>';
    let pager = '';
    for (let i = 0; i < $('.section').length; i++) {
      pager += pagerTemp;
    }
    $('#pager').html(pager);
    this.$pagerLine = $('#pager .line');
    TweenMax.set(this.$pagerLine, {drawSVG: '0%'});

    let isFirstSldie = false;
    let autoSlide;
    let loadingTimeVal = 3000; // ローディングを表示させてる時間
    let slideTimeVal; // スライドさせる時間
    let parser = new UAParser();
    let uaResult = parser.getResult();
    if(uaResult.device.type == "mobile" || uaResult.device.type == "tablet"){
      // SPまたはTablet
      slideTimeVal = 5000;
    } else if(uaResult.device.type != "mobile" || uaResult.device.type != "tablet"){
      // PC
      slideTimeVal = 10000;
    }

    // １つ目のビデオは初期化時点では一時停止
    let video = $('#videoContent').get(0);
    video.pause();

    TweenMax.set('#pager', { opacity: 0.0, y: 15 });
    TweenMax.set('.section .text', { opacity: 0.0, y: 15 });
    TweenMax.set('#section01 .inner', {scale: 1.0,});
    for (let i = 1; i < $('.section').length; i++) {
      let j = i + 1;
      TweenMax.set('#section0' + j + ' .inner', {scale: 1.5,});
    }

    // fullpage.js初期化
    function initialization() {
      $('#fullpage').fullpage({
        navigation: false, //ナビゲーションのONとOFF
        navigationPosition: 'right', //ナビゲーションの位置
        touchSensitivity: 15, //ブラウザの縦横比を定義して、スワイプ量によって次のセクションへ移動するかどうかの判別
        loopTop: true,
        loopBottom: true,
        loopHorizontal: true,
        // continuousVertical: true,
        afterLoad: function (anchorLink, index) {
          TweenMax.set($('#pager .line'), {drawSVG: '0%'});
          TweenMax.fromTo($('#pager .line').eq(index - 1), 0.6, {drawSVG: '0%'}, {drawSVG: '100%'}, 'show');

          let $this = $(this);
          let textItem = $this.find('.text');
          if(isFirstSldie){
            if(index == 1){
              video.play();
            }
            TweenMax.to(textItem, 0.8, {
              opacity: 1.0,
              y: 0,
              ease: Power2.easeInOut
            });
            autoSlide = setInterval(function () {
              $.fn.fullpage.moveSectionDown();
            }, slideTimeVal);
          }
        },
        onLeave: function (index, nextIndex, direction) {
          let $this = $(this);
          var textItem = $this.find('.text');
          if(index == 1){
            video.currentTime = 0;
          }
          if ($this) {
            TweenMax.to('#section0' + index + ' .inner', 0.8, {
              scale: 1.5,
              ease: Power2.easeInOut,
              onComplete: function () {

              }
            });
            TweenMax.to('#section0' + nextIndex + ' .inner', 0.8, {
              scale: 1.0,
              ease: Power2.easeInOut,
              onComplete: function () {
                TweenMax.set(textItem, { opacity: 0.0, y: 15 });
              }
            });
          }
          TweenMax.set($('#pager .line'), {drawSVG: '0%'});
          if(isFirstSldie){
            clearInterval(autoSlide);
            autoSlide = 0;
          }
        },
        // 初回起動時の1回しか叩かれない
        afterRender: function () {
          // window.console.log('afterRender');
        }
      });
      $.fn.fullpage.setAllowScrolling(false);
    }

    initialization();

    setTimeout(function () {
      TweenMax.to('main', 0.8, {
        top: 0,
        ease: Power2.easeInOut,
        onComplete: function () {
          if(!isFirstSldie) {
            video.play();
            // 初回のスライド
            setTimeout(function () {
              $.fn.fullpage.moveSectionDown();
            }, slideTimeVal);
          }
          isFirstSldie = true;
          // グロナビ表示アニメーション
          TweenMax.to('#headerNav, #header > .langSwitcher, #menuTrigger', 0.8, {
            y: 0,
            autoAlpha: 1,
            delay: 0.5,
            ease: Power3.easeInOut
          });
          // ページャー表示アニメーション
          TweenMax.to('#pager', 0.8,{
            opacity: 1.0,
            x: 0,
            ease: Power3.easeInOut,
            onComplete: function () {
              $.fn.fullpage.setAllowScrolling(true);
            }
          });
          // １つ目のセクションの文字表示アニメーション
          TweenMax.to('#section01 .text', 0.8, {
            opacity: 1.0,
            y: 0,
            ease: Power3.easeInOut
          });
        }
      });
    }, loadingTimeVal);

    // ナビゲーションに移動クリックイベントを紐付け
    $('#pager li').on({
      click: (e) => {
        var n = $(e.currentTarget).index();
        var nEdit = n + 1;
        $.fn.fullpage.moveTo(nEdit);
      }
    });
  }

}

//Contactページ
class Contact extends Page {
  constructor(id) {
    super(id);
    this.tl = new TimelineMax({
      paused: true
    })
      .from('#subSelector', 0.6, {marginTop: 50, autoAlpha: 0, ease: Power2.easeOut})
      .from('#detailMain .inner', 0.5, {x: '100%', ease: Power3.easeInOut}, '-=0.3')
      .from('#detailMain .image', 0.5, {x: '-100%', ease: Power3.easeInOut}, '-=0.5')
      .add(() => {
        new SlideIn();
      });

    // 個人情報同意チェックボックスの表示切り替え等の挙動
    $('.form__submit').prop('disabled', true);
    $('.form__checkbox #checkbox').on('click', function () {
      if ($(this).prop('checked') == false) {
        $('.form__submit button').prop('disabled', true);
        $('.form__checkbox').removeClass('change');
      } else {
        $('.form__submit button').prop('disabled', false);
        $('.form__checkbox').addClass('change');
      }
    });

    /*フォーム入力チェック機能 ここから*/
    //標準エラーメッセージの変更
    $.extend($.validator.messages, {
      required: '*入力必須です',
    });

    //追加ルールの定義
    let methods = {
      // お問い合わせ内容
      content_type: function (value, element, arg) {
        return arg !== value;
      }
    };

    //メソッドの追加
    $.each(methods, function (key) {
      $.validator.addMethod(key, this);
    });

    //入力項目の検証ルール定義
    let rules = {
      name: {required: true},
      name_company: {required: false},
      email: {required: true},
      tel: {required: true},
      content_type: {required: true, content_type: true},
      content: {required: true},
    };

    //入力項目ごとのエラーメッセージ定義
    let messages = {
      name: {
        required: "※入力必須項目です"
      },
      name_company: {
        required: "※入力必須項目です"
      },
      email: {
        required: "※入力必須項目です"
      },
      tel: {
        required: "※入力必須項目です"
      },
      content_type: {
        required: "※入力必須項目です"
      },
      content: {
        required: "※入力必須項目です"
      }
    };

    $('.form form').validate({
      rules: rules,
      messages: messages,

      //エラーメッセージ出力箇所調整
      errorPlacement: function (error, element) {
        if (element.is(':checkbox')) {
          error.appendTo(element.parent());
        } else {
          error.insertAfter(element);
        }
      }
    });
    /*フォーム入力チェック機能 ここまで*/

    /*モーダルイベント*/
    let current_scrollY;
    // モーダルを開く
    $('.form__checkbox a').on('click', function () {
      current_scrollY = $(window).scrollTop();
      $('#wrapper').css({
        position: 'fixed',
        width: '100%',
        top: -1 * current_scrollY
      });

      TweenMax.to($('#modalContainer'), 0.5, {
        display: "block",
        opacity: 1.0,
        ease: Power2.easeOut
      });

    });

    // モーダルを閉じる
    $('#modalContainer .modalClose').on('click', function (e) {
      $('#wrapper').attr({style: ''});
      $('#wrapper').attr({style: 'visibility: inherit; opacity: 1;'});
      $('html, body').prop({scrollTop: current_scrollY});

      TweenMax.to($('#modalContainer'), 0.5, {
        display: "none",
        opacity: 0.0,
        ease: Power2.easeOut
      });
    });

  }

  start() {
    this.tl.play();
  }


}

class lottieUtil {

  constructor(elm, dataPath, speedVal){

    this.elm = elm;
    this.dataPath = dataPath;
    this.speedVal = speedVal;
    this.anim = null;

    this.play = this._play.bind(this);
    this.stop = this._stop.bind(this);
    this.pause = this._pause.bind(this);
    this.destory = this._destory.bind(this);
    this.setSpeed = this._setSpeed.bind(this);

    this.setup();
    this.setSpeed(this.speedVal);
  }

  setup() {

    this.anim = lottie.loadAnimation({
      container: document.getElementById(this.elm),
      renderer: 'svg',
      loop: true,
      autoplay: false,
      path: this.dataPath
    });

  }

  /**
   * 再生
   * @private
   */
  _play() {
    this.anim.play();
  }

  /**
   * 停止
   * @private
   */
  _stop() {
    this.anim.stop();
  }

  /**
   * 一時停止
   * @private
   */
  _pause() {
    this.anim.pause();
  }

  /**
   * 破棄
   * @private
   */
  _destory() {
    this.anim.destroy();
  }

  /**
   * 再生スピード設定
   * @param int
   * @private
   */
  _setSpeed(int) {
    this.anim.setSpeed(int);
  }


}


// WEBPACK FOOTER //
// ./src/assets/js/_main.es6